export default __webpack_public_path__ + "static/media/todayOrdersActive.3e9a9cd1.svg";